import { render, staticRenderFns } from "./PDPAccordionItem.vue?vue&type=template&id=c951889c&scoped=true"
import script from "./PDPAccordionItem.vue?vue&type=script&lang=js"
export * from "./PDPAccordionItem.vue?vue&type=script&lang=js"
import style0 from "./PDPAccordionItem.vue?vue&type=style&index=0&id=c951889c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c951889c",
  null
  
)

export default component.exports